import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaBriefcase } from "react-icons/fa";

function Experience() {
  return (
    <Container fluid className="education-section">
      <Container>
        <h1 className="project-heading">
          Work <strong className="purple">Experience</strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={8}>
            <div className="education-card">
              <div className="education-icon">
                <FaBriefcase />
              </div>
              <div className="education-content">
                <h3 className="education-title">SDE Intern</h3>
                <h4 className="education-degree">Bluestocks</h4>
                <p className="education-period">2 Months</p>
                <p className="education-desc">
                  Worked as a Software Development Engineer Intern. Completed assigned tasks using MERN Stack technologies.
                  Gained hands-on experience in full-stack development and real-world project deployment.
                </p>
              </div>
            </div>

            <div className="education-card">
              <div className="education-icon">
                <FaBriefcase />
              </div>
              <div className="education-content">
                <h3 className="education-title">Full Stack Development Training</h3>
                <h4 className="education-degree">Apna College</h4>
                <p className="education-period">3 Months</p>
                <p className="education-desc">
                  Completed comprehensive training in Full Stack Development. Learned modern web technologies including
                  HTML, CSS, JavaScript, React, Node.js, and MongoDB. Built multiple projects during the course.
                </p>
              </div>
            </div>

            <div className="education-card">
              <div className="education-icon">
                <FaBriefcase />
              </div>
              <div className="education-content">
                <h3 className="education-title">Problem Solving & DSA</h3>
                <h4 className="education-degree">Self-paced Learning</h4>
                <p className="education-period">2024 - Present</p>
                <p className="education-desc">
                  Active participant in coding platforms. Solved problems on LeetCode, GeeksforGeeks,
                  and HackerRank. Strong foundation in data structures and algorithms.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Experience;